export const idPixel = "1707237506334160";
//  export const idPixel = "";
export const eventTypes = {
  verProducto: "VerProducto",
  compra: "Purchase",
};
